import off from './OFF.png'
import on from './ON.png'
import auto from './AUTO.png'
import manual from './MANUAL.png'
import offline from './OFFLINE.png'
import working from './Gears.gif'
import idle from './clock.gif'

import cnc from './CNC.png'
import edm from './EDM.png'
import cmm from './CMM.png'
import storage from './Storage.png'
import handler from './Handler.png'
import polish from './Polish.png'
import operator from './OPERATOR.png'
import camera from './CAMERA.png'
import marking from './MARKING.png'
import cleaning from './CLEANING.png'
import treatment from './TREATMENT_CENTER.png'
import deburring from './DEBURRING_CENTER.png'
import printer3d from './PRINTER_3D.png'

export const statusIcons = {
  off,
  on,
  auto,
  manual,
  offline,
  working,
  idle
}

export const machineIcons = {
  cnc,
  edm,
  cmm,
  storage,
  handler,
  polish,
  operator,
  camera,
  marking,
  cleaning,
  treatment,
  deburring,
  printer3d
}
